import React from 'react';

import 'normalize.css';
import 'html5-boilerplate/dist/css/main.css';
import './App.css';
import Main from './Main';

function App() {
    return <Main />;
}

export default App;
